module.exports = __webpack_public_path__ + "img/nccampus.4678509e.png";